import { getTabStatusLimits } from './TripStatus' 

/**
 * Filter trips list acording to the from OperPage
 */

const tags = (trip, query) => (
  !query.tag
  || query.tag == "all"
  || trip.tags[query.tag]
)

export default function filterTrips(trips: Object[], username, query) {
  const { tab, mine } = query
  const { minState, maxState } = getTabStatusLimits(tab)
  const x = trips.filter(trip => (
    trip && // discard nulls and shit
    (!tab || tab == "all" || (trip.status <= maxState && trip.status >= minState))
    && (!mine || trip.encargado == username) // #TODO get real login user
    && tags(trip, query)
  ))
  return x
}

